import React, {Component} from 'react';
import axios from "axios";
import FullCalendar from '@fullcalendar/react' // must go before plugins
import momentPlugin from '@fullcalendar/moment'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import getDateQry from "../../helpers/dateHelpers";
import {Fifteen_Out, Twenty_Out, Month_Out, Fourty_Five_Out, Two_Months} from "../../helpers/timePeriods";
import _ from 'lodash';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Moment from 'moment';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorLabel from '../../components/ErrorLabel/ErrorLabel';
import {connect} from "react-redux";
import css from '../SurveyCalendar/SurveyCalendar.module.scss';
import css2 from '../FieldJob2/FieldJob2.module.scss';

/**
 * @class
 */
const InstallCalendar = class extends Component {
    // ---------- class fields: ----------
    opportunityId = this.props.oppId;
    numDays = this.props.numDays;
    texasLocation = this.props.texasLocation;

    source = axios.CancelToken.source();

    postRequestFindDateCapacities = {
        "limit": 100,
        "skip": 0,
        "fields": [
            "Id",
            "Capacity_Type__c",
            "Date__c",
            "Location__c",
            "Slot_1_Available_Cap__c",
            "Slot_1_Total_Cap__c",
            "Slot_1_Taken_Capacity__c"
        ],
        "where": {
            "Capacity_Type__c": 'Install',
            "Skill_Options__c": {$ne: 'Combo'}
        },
        date: getDateQry(Twenty_Out, 'Date__c')
    };

    postRequestTexasLocationFindDateCapacities = {
        "limit": 100,
        "skip": 0,
        "fields": [
            "Id",
            "Capacity_Type__c",
            "Date__c",
            "Location__c",
            "Slot_1_Available_Cap__c",
            "Slot_1_Total_Cap__c",
            "Slot_1_Taken_Capacity__c"
        ],
        "where": {
            "Capacity_Type__c": 'Install',
            "Skill_Options__c": {$ne: 'Combo'}
        },
        date : getDateQry(Two_Months, 'Date__c') // two months: today to 60 days from now
    };

    postRequestFindLocations = {
        "limit": 10,
        "skip": 0,
        "fields": [
            "Id",
            "Name"
        ],
        "where": {
            "Active__c": true
        }
    };

    postRequestFindOpporunity = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Location__c",
            "Any_Code_Gates_Animals__c"
        ],
        "where": {
            "Id": this.opportunityId
        }
    }

    // ---------- state: ----------
    state = {
        // Fields for related opportunity
        opp: [],
        opportunityName: '',

        // Fields for session
        dateCapacities: [],
        sessionTime: '',
        dateCapacityIds: [],
        locationId: '',
        timeWindow: '',
        codeGateAnimals: '',

        // Fields for Salesforce Locations data
        locations: [],
        locationName: '',

        isSchedulingSurvey: false,
        isModelOpen: false,
        isMounted: false,
        disableButton: false,
        dayOfWeek: '',
        fifteenOut: Moment().add(15, 'days').format("YYYY-MM-DD"),
        twentyOut: Moment().add(20, 'days').format("YYYY-MM-DD"),
        monthOut: Moment().add(30, 'days').format("YYYY-MM-DD"),
        fourtyFiveOut: Moment().add(45, 'days').format("YYYY-MM-DD"),
        savingInstall:false,
        installBooked: false,
        installFailed: false,
        errorInstall: ''
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        window.scrollTo(0, 0);

        Promise.all([this.getLocations(), this.getOpportunity(), this.getDateCapacities()])
        .then((res) => {
            const locationData = res[0].data.records;
            const oppData = res[1].data;
            const dateCap = res[2].data.records;

            let dateCapacities = [];
            let dateCapacityIds = [];
            let loc = _.find(locationData, ['Id', oppData.Location__c]);

            dateCap.forEach(d => 
                {
                    dateCapacityIds.push({id: d.Id, location: d.Location__c, date: d.Date__c})
                    if(d.Slot_1_Taken_Capacity__c !== null){
                        let amount = d.Slot_1_Taken_Capacity__c/10;
                        for(var i = 0; i < amount; i++){
                            if(d.Location__c === loc.Id){
                                dateCapacities.push({title: 'Busy', start: d.Date__c + 'T07:30:00', end:  d.Date__c +'T16:30:00', color: '#f5c126', canSchedule: false})
                            }
                        }
                    }
                
                    if(d.Slot_1_Available_Cap__c !== null){
                        let amount = d.Slot_1_Available_Cap__c/10;
                        for(var a = 0; a < amount; a++){
                            if(d.Location__c === loc.Id){
                                let textColor = '#FFFFFF'; // white
                                let canSchedule = true;

                                // Texas location is allowed to show all date capacities, but only capacities that are 15 days from now can be used to schedule new sessions
                                if(this.texasLocation && d.Date__c < this.state.fifteenOut){
                                    textColor = '#8B0000'; // dark red
                                    canSchedule = false;
                                }

                                dateCapacities.push({title: 'Open', start: d.Date__c + 'T07:30:00', end:  d.Date__c +'T16:30:00', color: '#63c088', textColor, canSchedule})
                            }
                        }
                    }
                });

                this.setState(
                    {
                        opportunityName: oppData.Name,
                        codeGateAnimals: oppData.Any_Code_Gates_Animals__c,
                        dateCapacities,
                        dateCapacityIds,
                        locationName: loc.Name,
                        locationId: loc.Id,
                        isMounted: true
                    });
        });
    };

    componentWillUnmount() {
        this.source.cancel();
    };

    /**
     * @method
     * @methodOf CustomerDetails
     *
     * Fetches opportunity data.
     */
     getOpportunity = () => {
        return axios.get(
            `/sf/opportunity/findOne/${this.opportunityId}`,
            {
                cancelToken: this.source.token
            })
    };

    /**
     * @method
     * @methodOf LocationDetails
     *
     * Fetches location data.
     */
     getLocations = () => {
        return axios.post(
            '/sf/location/findNo',
            this.postRequestFindLocations,
            {
                cancelToken: this.source.token
            })
    };

    getDateCapacities = () => {
        let payload;

        if(!this.texasLocation){
            payload = this.postRequestFindDateCapacities;
        } else {
            payload = this.postRequestTexasLocationFindDateCapacities;
        }

        return axios.post(
            '/sf/DateCapacity/findNO',
            payload,
            {
                cancelToken: this.source.token
            })
    }

    handleEventClick = (info) => {
        let date = Moment(info.event.start).format('M/DD/YYYY');
        let startEnd = Moment(info.event.start).format('hh:mm A') + ' - ' + Moment(info.event.end).format('hh:mm A');
        let dateFormatTime = Moment(info.event.start);
        let currentTime = Moment();
        let oneDay = Moment().add(1, 'days').set('hour', 23).set('minute', 0);
        let sevenCheck = Moment().set('hour', 19).set('minute', 0);
        let dayOfWeek = Moment(info.event.start).format('dddd');
        
        if(info.event.extendedProps.canSchedule == true && dateFormatTime.get('date') !== currentTime.get('date') && currentTime < dateFormatTime){
            if(Moment(info.event.start).isBetween(currentTime, oneDay)){
                if(currentTime < sevenCheck){
                    this.setState({
                        isModelOpen: true,
                        sessionTime: date,
                        timeWindow: startEnd.toString(),
                        isSchedulingSurvey: true,
                        dayOfWeek: dayOfWeek
                    });
                }
            } else {
                this.setState({
                    isModelOpen: true,
                    sessionTime: date,
                    timeWindow: startEnd.toString(),
                    isSchedulingSurvey: true,
                    dayOfWeek: dayOfWeek
                });
            }
        }
    };

    closeModalOnClick = () => {
        this.setState(
            {
                isSchedulingSurvey: false
            }
        );
    };

    returnToCustomerPage = () => {
        this.props.onShouldShowCalendar(false);
    };

    render() {
        return (
            <React.Fragment>
            <div>
                <h4 className="m-0">Install Calendar</h4>
                <h1>{this.state.opportunityName}</h1>

                <div className="row">
                    <div className="col-sm-12">
                        <h3>Location</h3>
                    </div>
                </div>
                <div className="row">
                    {
                        this.state.isMounted ? 
                        (
                            <div className="col-sm-12">
                                <h2>{this.state.locationName} Calendar</h2>
                            </div>
                        )
                        :
                        (
                            <div></div>
                        )
                    }
                </div>

                <div className={css.fc}>
                <FullCalendar
                    plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin ]}
                    height="auto"
                    initialView="timeGridWeek"
                    initialDate={this.texasLocation ? this.state.fifteenOut : this.state.twentyOut}
                    navLinks="false"
                    hiddenDays={[0, 6]}
                    allDaySlot={false}
                    slotLabelInterval="09:00"
                    slotMinTime="07:30"
                    slotMaxTime="17:30"
                    slotLabelFormat={
                        {
                            hour: 'numeric',
                            minute: '2-digit',
                            meridiem: 'short'
                        }
                    }
                    titleFormat={ 
                        {
                            year: 'numeric', month: 'short', day: 'numeric'
                        }
                    }
                    headerToolbar={
                        {
                            left: 'prev,next',
                            center: 'title',
                            right: 'timeGridWeek,timeGridDay' 
                        }
                    }
                    footerToolbar={
                        {
                            center: 'today'
                        }
                    }
                    eventTimeFormat={
                        {
                            hour: 'numeric',
                            minute: '2-digit',
                            omitZeroMinute: true
                        }
                    }
                    eventSources={[this.state.dateCapacities]}
                    defaultTimedEventDuration="09:00"
                    slotEventOverlap={false}
                    eventClick={this.handleEventClick}
                />
                </div>

                <div className="col-sm-12 text-right">
                    <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button" onClick={this.returnToCustomerPage}>Cancel</button>
                </div>

                <Modal
                    isOpen={this.state.isModelOpen}
                    onRequestClose={() => this.setState({isModelOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <Formik 
                        initialValues={{
                            numDays: this.numDays,
                            codesGatesAnimals: this.state.codeGateAnimals,
                            installNotes: ''
                        }}
        
                        validate={
                            (values) => {
                                const errors = {};

                                if(!values.numDays.trim()) {
                                    errors.numDays = 'Missing Number of Days. Please try refreshing page or contact Sales Support';
                                }

                                if(values.numDays === "2") {
                                    let nextDay;
                                    let dateCapId;

                                    if(this.state.dayOfWeek === 'Friday'){
                                        nextDay = Moment(this.state.sessionTime).add(3, 'days').format('YYYY-MM-DD');
                                        dateCapId = _.find(this.state.dateCapacityIds, {'date': nextDay, 'location': this.state.locationId});
                                    } else {
                                        nextDay = Moment(this.state.sessionTime).add(1, 'days').format('YYYY-MM-DD');
                                        dateCapId = _.find(this.state.dateCapacityIds, {'date': nextDay, 'location': this.state.locationId});
                                    }

                                    if(dateCapId === null || dateCapId === undefined) {
                                        errors.numDays = 'No Available Capacity on Follow Up Day: ' + nextDay;
                                    }
                                }
        
                                return errors;
                            }
                        }
        
                        onSubmit={
                            async (values) => {
                                this.setState({
                                    disableButton: true,
                                    savingInstall: true
                                });

                                const oppPayload = {
                                    Id: this.opportunityId,
                                    Any_Code_Gates_Animals__c: values.codesGatesAnimals
                                }

                                axios.put(
                                    '/sf/opportunity/update',
                                    oppPayload,
                                    {
                                        cancelToken: this.source.token
                                    })
                                    .catch(err => console.log('(PUT) Error while trying to update opportunity: \n', err));

                                let sessionTime = Moment(this.state.sessionTime).format('YYYY-MM-DD')
                                let dateCapId = _.find(this.state.dateCapacityIds, {'date': sessionTime, 'location': this.state.locationId});
                                let installDate = Moment(this.state.sessionTime).format('MM/DD/YYYY');

                                const sessPayload = {
                                    Name: this.state.opportunityName + ": Install " + sessionTime,
                                    RecordTypeId: "0121N000001LzeC",
                                    Schedulable_Event__c: "a151N0000063hO1", //Install Standard [Sac]
                                    Scheduled_Date_Capacity__c: dateCapId.id,
                                    Opportunity__c: this.opportunityId,
                                    Scheduled_Date__c: new Date(installDate),
                                    Number_of_surveyors_needed__c: "1",
                                    Location__c: this.state.locationId,
                                    Time_Window__c: this.state.timeWindow,
                                    Time_Slot_Count__c: "1",
                                    Number_of_days__c: values.numDays,
                                    Codes_Gates_Animals__c: values.codesGatesAnimals,
                                    Scheduled_w_Jurisdiction__c: false,
                                    Schedulable_Notes__c: values.installNotes,
                                    Rep_Scheduled__c: true,
                                    Install_Type__c: 'Install'
                                };

                                if(values.numDays === "1") {
                                    await axios.post(
                                        '/sf/schedulable/create',
                                        sessPayload,
                                        {
                                            cancelToken: this.source.token
                                        })
                                        .then((res) => {
                                            console.log(res.data)

                                            this.setState({
                                                installBooked: true,
                                                savingInstall: false
                                            });
                                        })
                                        .catch(err => {
                                            console.log('(POST) Error while trying to create session:\n', err)

                                            this.setState({
                                                installFailed: true,
                                                savingInstall: false,
                                                errorInstall: err
                                            });
                                        });

                                } else if(values.numDays === "2") {
                                    let nextDay;
                                    let nextDateCapId;
                                    let nextInstallDate

                                    if(this.state.dayOfWeek === 'Friday'){
                                        nextDay = Moment(this.state.sessionTime).add(3, 'days').format('YYYY-MM-DD');
                                        nextDateCapId = _.find(this.state.dateCapacityIds, {'date': nextDay, 'location': this.state.locationId});
                                        nextInstallDate = Moment(this.state.sessionTime).add(3, 'days').format('MM/DD/YYYY');
                                    } else {
                                        nextDay = Moment(this.state.sessionTime).add(1, 'days').format('YYYY-MM-DD');
                                        nextDateCapId = _.find(this.state.dateCapacityIds, {'date': nextDay, 'location': this.state.locationId});
                                        nextInstallDate = Moment(this.state.sessionTime).add(1, 'days').format('MM/DD/YYYY');
                                    }

                                    const sessPayload2 = { ...sessPayload };
                                    sessPayload2.Name = this.state.opportunityName + ": Install " + nextDay;
                                    sessPayload2.Scheduled_Date_Capacity__c = nextDateCapId.id
                                    sessPayload2.Scheduled_Date__c = new Date(nextInstallDate);

                                    await axios.post(
                                        '/sf/schedulable/create',
                                        sessPayload,
                                        {
                                            cancelToken: this.source.token
                                        })
                                        .then((res) => {
                                            console.log(res.data);

                                            axios.post(
                                                '/sf/schedulable/create',
                                                sessPayload2,
                                                {
                                                    cancelToken: this.source.token
                                                })
                                                .then((res) => {
                                                    console.log(res.data)
                                                    
                                                    this.setState({
                                                        installBooked: true,
                                                        savingInstall: false
                                                    });
                                                })
                                                .catch(err => {
                                                    console.log('(POST) Error while trying to create session:\n', err);
        
                                                    this.setState({
                                                        installFailed: true,
                                                        savingInstall: false,
                                                        errorInstall: err
                                                    });
                                                });
                                        })
                                        .catch(err => {
                                            console.log('(POST) Error while trying to create session:\n', err);

                                            this.setState({
                                                installFailed: true,
                                                savingInstall: false,
                                                errorInstall: err
                                            });
                                        });
                                }
                            }
                        }
                    >
                        <Form>
                            <div className="d-flex justify-content-between text-white">
                                <h3>Schedule Install on {this.state.sessionTime} {this.state.timeWindow}</h3>

                                <span className="mx-2 cursor-pointer">
                                    <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({isModelOpen: false, isSchedulingSurvey: false})} />
                                </span>
                            </div>
                            <div className="mt-3 text-white">
                                <label>Number of Days for Installation</label>
                                <Field className="input" type="text" name="numDays" disabled  />
                                <ErrorMessage name="numDays" component={ErrorLabel} />
                            </div>
                            <div className="mt-3 text-white">
                                <label>CU Preferences/Access Info</label>
                                <Field className="input" type="text" name="codesGatesAnimals" />
                            </div>
                            <div className="mt-3 text-white">
                                <label>Any Install Notes?</label>
                                <Field className="input" type="text" maxlength="1500" name="installNotes" />
                            </div>
                            <div className={this.state.installBooked || this.state.savingInstall || this.state.installFailed  ? 'd-none' : 'mt-3 text-center'}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" type="submit" disabled={this.state.disableButton}>Schedule Install</button>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.setState({isModelOpen: false})}>Cancel</button>
                            </div>
                            <div className={this.state.savingInstall ? 'text-white text-center pt-3' : 'd-none'}>
                                <div className={css2.FieldJob2__Loader}></div>
                                <h2 className='pt-3'>Booking Installs: Please Wait</h2>
                            </div>
                            <div className={this.state.installBooked ? 'text-white text-center pt-3' : 'd-none'}>
                                <h2 className='pt-3'>Installs Successfully Scheduled</h2>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.returnToCustomerPage()}>Done</button>
                            </div>
                            <div className={this.state.installFailed ? 'text-white text-center pt-3' : 'd-none'}>
                                <h2 className='pt-3'>Error Scheduling Install: {this.state.errorInstall}</h2>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.returnToCustomerPage()}>Done</button>
                            </div>
                            <h2>&nbsp;&nbsp;</h2>
                        </Form>
                    </Formik>
                </Modal>
            </div>
            </React.Fragment>
        );
    }
}

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(InstallCalendar);